import styled from 'styled-components';
import { sa } from '../superAdminUi';

// Local styling for the User Management section. Kept out of the shared appStyle.js so this
// feature owns its own chrome; the table itself reuses the shared Super Admin DataTable.

// Newest-first list of login / MFA / admin events shown when a row is expanded.
export const Timeline = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  font-family: ${sa.font.family};

  li {
    position: relative;
    padding: 0 0 18px 22px;
    border-left: 2px solid ${sa.color.stroke};
  }

  li:last-child {
    border-left-color: transparent;
    padding-bottom: 0;
  }

  li::before {
    content: '';
    position: absolute;
    left: -6px;
    top: 4px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${sa.color.teal};
  }

  .event-title {
    display: block;
    font-weight: ${sa.font.semibold};
    font-size: 13px;
    color: ${sa.color.text};
  }

  .event-meta {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: ${sa.color.textGray};
  }
`;
